module.exports = __webpack_public_path__ + "img/6.929a608c.jpg";